import { render, staticRenderFns } from "./ProductSection.vue?vue&type=template&id=72730039&scoped=true"
import script from "./ProductSection.vue?vue&type=script&lang=js"
export * from "./ProductSection.vue?vue&type=script&lang=js"
import style0 from "./ProductSection.vue?vue&type=style&index=0&id=72730039&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72730039",
  null
  
)

export default component.exports